export default __webpack_public_path__ + "static/media/TableInactive.2dfed94a.svg";